<template>
  <block
    component-name="block-media-videoplayer"
    body-class="relative top-0 left-0 grid grid-cols-12"
  >
    <wrapper-reveal
      reveal="fade-from-bottom"
      class="w-full col-span-full phablet:col-start-2 phablet:col-end-12 tablet:col-start-3 tablet:col-end-11"
    >
      <videoplayer
        :useYoutube="$attrs.config.useYotube || false"
        :video-id="$attrs.data.body.video.videoId || undefined"
        :use-loop="true"
        :title="$attrs.data.body.video.title || undefined"
        :cdn="$attrs.data.body.video.cdn || undefined"
        :src="$attrs.data.body.video.src || undefined"
        :poster="$attrs.data.body.video.poster || undefined"
        :width="$attrs.data.body.video.width || undefined"
        :height="$attrs.data.body.video.height || undefined"
        :aspect-ratio="$attrs.data.body.video.aspectRatio || undefined"
        :pretty-name="$attrs.data.body.video.pretty_name || undefined"
        class="w-full"
      />
    </wrapper-reveal>
  </block>
</template>
